// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var BadgeWrapper = styled.div({
  display: 'inline-flex',
  marginLeft: "var(--ds-space-050, 4px)",
  opacity: 0.5
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var Container = styled.div({
  display: 'inline-flex',
  alignItems: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var LabelValueWrapper = styled.div({
  marginLeft: "var(--ds-space-050, 4px)",
  display: 'inline-flex',
  alignItems: 'center'
});